import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import apiRoutes from '@/lib/apiRoutes';
import { publicHttpClient } from '@/lib/httpClient';
import type { DefaultQueryError } from '../types';
import type { ServiceModalData } from './types';

type Params = {
  lat: number;
  lng: number;
  city_id: string;
};

export const getServiceModelsFn = async (params: Partial<Params>) => {
  const response = await publicHttpClient.get<ServiceModalData[]>(
    apiRoutes.services.service_models,
    {
      params,
    }
  );
  return response.data;
};

export const useGetServiceModels = (
  params: Partial<Params>,
  opts?: UseQueryOptions<ServiceModalData[], DefaultQueryError>,
  additionQueryKey?: { rentType: string }
) =>
  useQuery<ServiceModalData[], DefaultQueryError>(
    [apiRoutes.services.service_models, { ...params, ...additionQueryKey }],
    () => getServiceModelsFn(params),
    opts
  );
